module.exports = __webpack_public_path__ + "src/assets/img/sp1.618b9190.png";